import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { TerminationEdit } from '../../modules/NewHire/components/TerminationEdit';
import { hrCheck } from '../../tools/permissionChecks';

export const Route = createFileRoute('/hrDashboard/newFire/edit/$userId')({
  component: RouteComponent,
  params: z.object({
    userId: z.coerce.number().positive(),
  }),
  loader(ctx) {
    // Only HR may access/edit a termination record once it has been created.
    const permissionCheck = hrCheck(ctx.context.authContext.user);
    if (!permissionCheck) {
      toast({
        title: 'Access Denied',
        description:
          'Only HR can access or edit termination records. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'HR Dashboard - Edit Termination' }],
    };
  },
});

function RouteComponent() {
  const params = Route.useParams();
  return <TerminationEdit userId={params.userId} />;
}
